module.exports = __webpack_public_path__ + "static/media/editPen.d66dff11.svg";